import { forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import MDBox from "../MDBox";
import MDTypography from "../MDTypography";
import PropTypes from "prop-types";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import InfoIcon from "@mui/icons-material/Info";
const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const CustomInfoDialog = (props) => {
  const {
    open,
    setOpenDialog,
    title,
    messageLine1,
    messageLine1Node,
    goText,
    type,
    navigateToUrl,
    handleClose,
  } = props;
  const navigate = useNavigate();
  const close = () => {
    setOpenDialog(false);

    if (navigateToUrl !== undefined && navigateToUrl !== "") {
      navigate(navigateToUrl);
    }
  };

  const dialogMessageLine1Styles = {
    fontWeight: "600",
    fontSize: "1.35rem",
    lineHeight: "1.375",
  };

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={close}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>
          {title}
          <CloseIcon
            aria-label="close"
            onClick={close}
            sx={{
              position: "absolute",
              right: 8,
              top: 16,
            }}
          />
        </DialogTitle>

        <DialogContent>
          <MDBox
            display="flex"
            maxHeight="35vh"
            justifyContent="center"
            alignItems="center"
            sx={({ breakpoints }) => ({
              minWidth: "30rem",
              alignItems: "left",
              [breakpoints.down("md")]: {
                fontSize: "medium",
                minWidth: "15rem",
              },
            })}
          >
            <Grid container justifyContent={"center"}>
              <Grid
                item
                xs={12}
                sx={{
                  fontSize: "7rem",
                  marginTop: "15px",
                  marginBottom: "20px",
                }}
                textAlign="center"
              >
                {type == "error" ? (
                  <ErrorIcon color="error" />
                ) : type == "success" ? (
                  <CheckCircleIcon color="primary" />
                ) : (
                  type == "info" && <InfoIcon color="warning" />
                )}
              </Grid>
              <Grid item xs={12} textAlign="center">
                <MDTypography sx={dialogMessageLine1Styles}>
                  {messageLine1}
                </MDTypography>
                {messageLine1Node}
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose ?? close()}>{goText}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomInfoDialog;

CustomInfoDialog.propTypes = {
  type: PropTypes.oneOf(["info", "error", "success", "none"]),
};

CustomInfoDialog.defaultProps = {
  title: "",
  messageLine1: "Apologies, an error has occured.",
  goText: "OK",
  type: "info",
  navigateTo: "",
  open: true,
};
